import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

export interface IChartCardProps extends React.PropsWithChildren {
  /**
   * Rendered above the chart content (typically a `ChartHeader` or a chart-specific header).
   */
  header: React.ReactNode;
  /**
   * Attached to the outermost card div. Consumers using `useContainerWidth` pass their ref here
   * so they can measure the full card width.
   */
  containerRef?: React.Ref<HTMLDivElement>;
  /**
   * Additional classes for the outer card.
   */
  className?: string;
  /**
   * Additional classes for the inner content wrapper that holds the chart body.
   */
  contentClassName?: string;
}

/**
 * Shared card scaffold for dashboard-style chart cards. Handles the outer rounded
 * container, background, and shadow, and renders a header above the chart body in
 * a padded content region. Consumers compose their header (usually `ChartHeader`)
 * and their chart body (`ResponsiveContainer`, etc.) as children/props.
 */
export const ChartCard = ({ header, containerRef, className, contentClassName, children }: IChartCardProps) => {
  return (
    <div
      ref={containerRef}
      className={cx(
        'bg-secondary_subtle border-secondary shadow-card flex shrink-0 flex-col overflow-hidden rounded-2xl border',
        className
      )}
    >
      {header}
      <div className={cx('shadow-xs px-5 pb-5 pt-5', contentClassName)}>{children}</div>
    </div>
  );
};
